import request from '@/service/http'

export function searchInit (data) {
  return request({
    url: 'api/TestPaperBank/searchInit',
    method: 'post',
    data,
  })
}

export function searchList (data) {
  return request({
    url: 'api/TestPaperBank/searchList',
    method: 'post',
    data,
  })
}

export function testPagerDelete (data) {
  return request({
    url: 'api/TestPaperBank/delete',
    method: 'post',
    data,
  })
}

export function testQuestionSave (data) {
  return request({
    url: 'api/TestPaperBank/testQuestionSave',
    method: 'post',
    data,
  })
}

export function actualTestQuestionSave (data) {
  return request({
    url: 'api/TestPaperBank/actualTestQuestionSave',
    method: 'post',
    data,
  })
}

export function testQuestionDetail (data) {
  return request({
    url: 'api/TestPaperBank/detail',
    method: 'post',
    data,
  })
}

export function testQuestionUpdate (data) {
  return request({
    url: 'api/TestPaperBank/update',
    method: 'post',
    data,
  })
}

export function actualTestQuestionDetail (data) {
  return request({
    url: 'api/TestPaperBank/actualDetail',
    method: 'post',
    data,
  })
}

export function actualTestQuestionUpdate (data) {
  return request({
    url: 'api/TestPaperBank/actualQuestionUpdate',
    method: 'post',
    data,
  })
}